import Vue from "vue";
import { ISocket } from "@/store/types/types";
import { RootState } from "@/store/types/root";
import { ActionContext } from "vuex";

const vue: ISocket = new Vue();

const state = {
  isConnected: false,
  message: "",
  reconnectError: false,
  connect: false
};

type State = typeof state;

const mutations = {
  SOCKET_ONOPEN(state: State) {
    state.isConnected = true;
  },
  SOCKET_ONCLOSE(state: State) {
    state.isConnected = false;
    state.connect = false;
  },
  SOCKET_ONERROR(state: State, event: string) {
    console.info(state, event);
  },
  // default handler called for all methods
  SOCKET_ONMESSAGE(state: State, message: string) {
    state.message = message;
  },
  // mutations for reconnect methods
  SOCKET_RECONNECT(state: State, count: string) {
    console.info(state, count);
  },
  SOCKET_RECONNECT_ERROR(state: State) {
    state.reconnectError = true;
  },
  setConnect(state: State, status: boolean) {
    state.connect = status;
  }
};

const actions = {
  sendSocketMessage: (_: ActionContext<State, RootState>, message: string) => {
    vue.$socket.send(message);
  }
};

const getters = {
  socketConnectionState: (state: State) => state.isConnected,
  getMessage: (state: State) => state.message,
  getConnect: (state: State) => state.connect
};

export default {
  state,
  mutations,
  actions,
  getters
};
